import { SelectFormField } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import _ from 'lodash';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { createNumberWithSuffix } from 'utils/numberUtils';
import { IFormValidation } from '@busybusy/webapp-react-ui/dist/types/Validation';

interface IDayOfMonthFormFieldProps {
  name: string;
  form: any;
  validations?: Array<IFormValidation<string>>;
  disabled?: boolean;
  hasArrow?: boolean;
  onBlur?: () => void;
  onChange?: (value: string) => void;
  onClick?: () => void;
  onFocus?: () => void;
  onKeyDown?: () => void;
  placeholder?: string;
  className?: ClassName;
}

const DayOfMonthFormField: FunctionComponent<IDayOfMonthFormFieldProps> = (props) => {
  const { name, form, className, ...selectProps } = props;

  const [t] = useTranslation();

  const classes = classNames(
    {
      'day-of-month-range-form-field': true,
    },
    className
  );

  return (
    <SelectFormField
      form={form}
      name={name}
      className={classes}
      options={_.times(31, (num) => createNumberWithSuffix(num + 1)).map((suffixed) => ({
        value: suffixed,
        label: t(suffixed),
      }))}
      {...selectProps}
    />
  );
};

export default DayOfMonthFormField;
